<div class="promotions-slider aspect-ratio-ssr">
  <!-- SEO -->
  <ng-container *ngIf="platform.isServer">
    <ng-container *ngFor="let slide of sliders">
      <ng-container *ngTemplateOutlet="link; context: { url: slide.link, imageUrl: slide.imagePath }">
      </ng-container>
    </ng-container>
  </ng-container>
  <!-- /SEO -->
  <ng-container *ngIf="platform.isBrowser && sliders && sliders.length">
    <owl-carousel-o
      *ngIf="sliders.length > 1; else singleBanner"
      [options]="promotionsSliderOptions"
    >
      <ng-template carouselSlide *ngFor="let slide of sliders">
        <div class="aspect-ratio">
          <ng-container *ngTemplateOutlet="link; context: { url: slide.link, imageUrl : slide.imagePath }">
          </ng-container>
        </div>
      </ng-template>
    </owl-carousel-o>

    <ng-template #singleBanner>
      <ng-container *ngTemplateOutlet="link; context: { url: sliders[0].link, imageUrl: sliders[0].imagePath }">
      </ng-container>
    </ng-template>
  </ng-container>
</div>

<ng-template let-imageUrl="imageUrl" #imgTemplate>
  <img
    class="rounded-l block"
    [class.promotions-slider-max-w-img]="sliders && sliders.length === 1"
    [src]="imageUrl | formatLink"
    [alt]="imageUrl | formatLink"
    (load)="onImgLoad($event)"
    (error)="onImgError($event)"
    [style.visibility]="'hidden'"
  />
</ng-template>

<ng-template #link let-url="url" let-imageUrl="imageUrl">
  <a *ngIf="isAbsoluteLink(url); else clientRoutingLink" [href]="url">
    <ng-container
      [ngTemplateOutlet]="imgTemplate"
      [ngTemplateOutletContext]="{
        imageUrl: imageUrl
      }">
    </ng-container>
  </a>
  <ng-template #clientRoutingLink>
      <a [routerLink]="url">
        <ng-container
          [ngTemplateOutlet]="imgTemplate"
          [ngTemplateOutletContext]="{
            imageUrl: imageUrl
          }">
        </ng-container>
      </a>
  </ng-template>
</ng-template>
